import {M3uMedia} from "../../lib/m3u/m3u-model";
import IconButton from "../common/IconButton";
import Input from "../common/Input";
import styles from "./manual.add.shortlist.module.css";
import React, {useCallback} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {M3uParser} from "../../lib/m3u";
import {playlistShortlistService} from "../../services/playlist/PlaylistShortlistService";
import Collapsable from "../common/Collapsable";
import logger from "../../lib/logger";

interface Props {
    onAdded?: (channel: M3uMedia) => void;
    useCollapsable?: boolean;
}

export const AddToShortlist = ({onAdded, useCollapsable}: Props) => {

    const inputRefUrl = React.useRef<HTMLInputElement>(null);
    const inputRefName = React.useRef<HTMLInputElement>(null);

    const addToShortlist = useCallback((channel: M3uMedia) => {
        playlistShortlistService.add(channel).then(() => {
            if (onAdded) {
                onAdded(channel)
            }
        });
    }, [onAdded]);

    const saveToShortlist = () => {
        const url = inputRefUrl.current?.value;
        const name = inputRefName.current?.value;

        if (url && name) {
            var newChannel: M3uMedia = new M3uMedia()
            newChannel.location = url
            newChannel.mimeType = M3uParser.mimeTypeExtractor(url)
            newChannel.name = name
            addToShortlist(newChannel)

            // Clear input fields after successful addition
            if (inputRefUrl.current) inputRefUrl.current.value = '';
            if (inputRefName.current) inputRefName.current.value = '';
        } else {
            logger.warn("URL and name are required to add a channel to the shortlist.");
        }
    }

    const doFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        saveToShortlist();
    };

    const formContent = (

        <div className={styles.formContainer}>
            <form onSubmit={doFormSubmit} className={styles.formstyling}>
                <Input id="title" placeholder="Title" innerRef={inputRefName} name="title" type="text"/>
                <Input id="url" placeholder="Url" innerRef={inputRefUrl} name="url" type="text"/>
                <IconButton onClick={saveToShortlist} type="button" tooltip="Legg til shortlist"
                            icon={<FontAwesomeIcon icon={faPlus}/>}/>
            </form>
        </div>
    );

    if (useCollapsable) {
        return (
            <Collapsable defaultExpanded={false} maximizedText={' - Legg til shortlist'}
                         minimizedText={'+ Legg til shortlist'}>
                {formContent}
            </Collapsable>
        );
    } else {
        return formContent;
    }
}